import React, { FC, useMemo } from 'react'

import { ambassadorHttpClient } from '../../../api/httpClient'
import { BusinessTermService } from '../../reusable/Category/api/BusinessTermService'
import { CategoryLayout } from '../../reusable/Category/constants'
import { BrandedAppCategory as BrandedAppCategoryUnwrapped } from './BrandedAppCategory'

export const BrandedAppCategory: FC = () => {
  const businessTermService = useMemo(() => new BusinessTermService(ambassadorHttpClient), [])
  return <BrandedAppCategoryUnwrapped businessTermService={businessTermService} layout={CategoryLayout.NEW_CONCEPT} />
}
